import React from 'react';
import { CheckCircle2Icon, LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { GoldPlaque } from '../ui/GoldPlaque';
import { CtaButton } from '../ui/CtaButton';
import { BundleMockup } from '../product/BundleMockup';
import { bonuses } from '../../data/bonuses';
import { CHECKOUT_NOTE, DELIVERY_NOTE, offerCoreInclusions, optionalExtras } from '../../data/site';
export function Offer() {
  return <section id="offer-details" aria-labelledby="offer-title" className="bg-mint py-20 text-ink lg:py-24" data-id="element-216" data-mp="3a4nog0fy2vdt">
      <div className="mx-auto max-w-page px-5 text-center lg:px-8" data-id="element-217" data-mp="3f38n3vfjt705">
        <GoldPlaque tone="light" data-id="element-218" data-mp="3juqi82uw4dd7">The complete pack</GoldPlaque>
        <h2 id="offer-title" className="mx-auto mt-6 max-w-4xl font-display text-[44px] font-bold uppercase leading-[0.92] sm:text-[64px] lg:text-[84px]" data-id="element-219" data-mp="3jxmdfjfcsnxy">
          Your handball unit, <span className="text-gold-dark" data-id="element-220" data-mp="3su3suyur37zi">ready to teach</span>
        </h2>

        <div className="mx-auto mt-12 max-w-[576px] overflow-hidden rounded-2xl border border-[#D6E5EF] border-t-[5px] border-t-go bg-white text-left shadow-[0_28px_60px_-34px_rgba(7,28,51,0.30)]" data-id="element-221" data-mp="1pwwvnzdlca1">
          <div className="p-5 sm:p-10" data-id="element-222" data-mp="1fl2cgzlhgyks">
            <p className="text-center text-[13px] font-bold uppercase tracking-[0.16em] text-gold-ink" data-id="element-223" data-mp="1bkij87416f3x">
              Core guide + 5 bonuses
            </p>
            <h3 className="mt-2 text-center font-display text-[30px] font-bold uppercase leading-none sm:text-[36px]" data-id="element-224" data-mp="16njlzfp2ls1i">
              Handball Class Ready — Complete Pack
            </h3>

            <div className="mt-8" data-id="element-225" data-mp="1zaw9pt6yw5we">
              <BundleMockup data-id="element-226" data-mp="1ujo12zdgooka" />
            </div>
            <p className="mt-5 text-center text-sm text-[#4B5563]" data-id="element-227" data-mp="1uicxp0nxhitp">Digital PDF files — nothing is shipped.</p>

            <hr className="my-8 border-[#E5E7EB]" data-id="element-228" data-mp="1pk1n2npt74af" />

            <p className="font-display text-[22px] font-bold uppercase" data-id="element-229" data-mp="2mzp0lb8qfnk5">What’s included</p>
            <ul className="mt-4 grid gap-x-5 gap-y-3 sm:grid-cols-2" data-id="element-230" data-mp="2i98i3cq21bqx">
              {offerCoreInclusions.map(item => <li key={item} className="flex gap-2.5 text-base" data-id="element-231" data-mp="3157folg4pgpx">
                  <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-go-hover" data-id="element-232" data-mp="364kb3ul2fw44" />
                  {item}
                </li>)}
              {bonuses.map((bonus, index) => <li key={bonus.name} className="flex gap-2.5 text-base" data-id="element-233" data-mp="2we8vhas0ryhe" data-mpi={index}>
                  <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" data-id="element-234" data-mp="2wcea5vcu64cs" />
                  <span data-id="element-235" data-mp="2ne2ng4f3bqpm">
                    <span className="font-bold" data-id="element-236" data-mp="2necd1qw83vus">Bonus {index + 1}:</span> {bonus.name}
                  </span>
                </li>)}
            </ul>
            <p className="mt-6 border-t border-[#E5E7EB] pt-4 text-sm leading-relaxed text-[#4B5563]" data-id="element-237" data-mp="29gntqnht0wru">
              Not included: {optionalExtras.join(' and ')} are separate, optional products offered at checkout. This
              pack is complete without them.
            </p>

            <hr className="my-8 border-[#E5E7EB]" data-id="element-238" data-mp="bnqgwgqryng2" />

            <div className="text-center" data-id="element-239" data-mp="1w5spio3mdk9q">
              <p className="font-display font-bold leading-none text-forest" data-id="element-240" data-mp="1w6tzsqcta2qe">
                <span className="text-[96px] sm:text-[112px]" data-id="element-241" data-mp="1s6a1vkkeyv37">$27</span>
                <span className="ml-2 align-top text-[28px] sm:text-[32px]" data-id="element-242" data-mp="25wwztaicogy8">USD</span>
              </p>
              <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.16em] text-[#374151]" data-id="element-243" data-mp="215f0srzw0qfw">One-time purchase</p>
            </div>

            <CtaButton target="checkout" size="xl" className="mt-8 w-full" data-id="element-244" data-mp="2fsqd4w3w8eh2">
              Get the pack now
            </CtaButton>

            <ul className="mt-8 space-y-3 text-base text-[#1F2937]" data-id="element-245" data-mp="2ov9bp40nc4xi">
              <li className="flex gap-3" data-id="element-246" data-mp="2ougd4qbuclqg">
                <ShieldCheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-go-hover" data-id="element-247" data-mp="2jvn0f04doyrc" />
                <span data-id="element-248" data-mp="ugoy1baqt9nm">
                  <span className="font-bold" data-id="element-249" data-mp="ui0096oji9cm">10-day money-back guarantee.</span> Not right for your classes? Request a
                  refund within 10 days.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-250" data-mp="rw0o3f9nzqly">
                <MailIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-go-hover" data-id="element-251" data-mp="rz4yiudq3il2" />
                {DELIVERY_NOTE}
              </li>
              <li className="flex gap-3" data-id="element-252" data-mp="10yibhx122paj">
                <LockIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-go-hover" data-id="element-253" data-mp="10vdxy91pah77" />
                {CHECKOUT_NOTE}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}